import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type AccountState = {}

const initialState: AccountState = {}

const accountSlice = createSlice({
  initialState,
  name: 'account',
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setNewUserEmail(state, action: PayloadAction<string>) {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setSelectedCurrency(state, action: PayloadAction<string>) {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setShowNotifications(state, action: PayloadAction<string>) {}
  }
})

export const { actions } = accountSlice
export default accountSlice.reducer
